import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.baseApiUrl;
  hasPermissionValue: boolean = false;
  isAuthenticated(): boolean {
    const accessToken = localStorage.getItem('access_token');
    return !!accessToken;
  }

  constructor(private http: HttpClient) { }

  exchangeCodeForToken(code: string): Observable<any> {
    const apikey = environment.apiKey;
    //Create the header object and passing the API key 
    const headers = new HttpHeaders().set('Token', apikey);
    return this.http.get(this.baseUrl + 'Auth/GetAccessToken?code=' + code, { headers });
  }

  getUserInfo(accessToken: string) {
    //Create the header object and passing the Access Token 
    const headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    return this.http.get<any>(this.baseUrl + 'Auth/GetUserInfo', { headers });
  }

  setPermissionStatus(hasPermission: boolean) {
    this.hasPermissionValue = hasPermission;
  }

  hasAuthorized(): boolean {
    return this.hasPermissionValue;
  }

  getApgAccessToken(accessToken: string) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    return this.http.get<any>(this.baseUrl + 'Auth/GetAPIGEEAccessToken', { headers });
  }

  getApgAuthorization(accessToken: string, apitoken: string) {
    let aeroToken: any = localStorage.getItem('AeroJwtToken');
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${accessToken}`,
        'apiGeeToken': apitoken,
        'jwtToken': aeroToken
      })
    };
    return this.http.get<any>(this.baseUrl + 'Auth/GetAPIGEEAdmindetails', httpOptions);
  }

  logout() {
    window.location.replace(environment.aeroHomeUrl);
  }
}
